import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Department } from '@app/models/company/department.model';

@Component({
    selector: 'journal-entry-report-settings-department-form',
    templateUrl: './journal-entry-report-settings-department-form.template.html',
})
export class JournalEntryReportSettingsDepartmentForm {
    @Input() departments: Department[] = [];
    @Output() departmentCodeChange: EventEmitter<Department> = new EventEmitter<Department>();

    onDepartmentCodeChanged(department: Department): void {
        this.departmentCodeChange.emit(department);
    }
}
